import { render, staticRenderFns } from "./bimPagination.vue?vue&type=template&id=e30c5176&scoped=true&lang=html&"
import script from "./bimPagination.vue?vue&type=script&lang=js&"
export * from "./bimPagination.vue?vue&type=script&lang=js&"
import style0 from "./bimPagination.vue?vue&type=style&index=0&id=e30c5176&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30c5176",
  null
  
)

export default component.exports